export const ResumenDetalle = {
    CodigoTarifa: "",
    Tarifa: 0,
    UnidadMedida: "",
    SubTotalLinea: 0.0,
    Clave: "",
    Monto: 0.0
}